// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"FormLabel_componentStyle__6V_rY"};